import Navbar from "../../components/common/Navbar";
import Header from "../../components/common/Header";
import StoreGrid from "../../components/store/StoreGrid";
import Footer from "../../components/common/Footer";

const Store = ({}) => {
  return (
    <>
      <Navbar />
      <Header title={"VGC Store"} />
      <div className="body">
        <StoreGrid />
      </div>
      <Footer />
    </>
  );
};

export default Store;
